import Html from "./Html";
import { Provider } from "./Provider";


const FtmApprovalProcess = () => {
    return (
        <Provider>
            <Html/>
        </Provider>
    );
};

export default FtmApprovalProcess;